import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import bgCommon from '@/locales/bg/common.json'
import bgAuth from '@/locales/bg/auth.json'
import bgDashboard from '@/locales/bg/dashboard.json'
import bgPatients from '@/locales/bg/patients.json'
import bgStaff from '@/locales/bg/staff.json'
import bgDocuments from '@/locales/bg/documents.json'
import bgFinancials from '@/locales/bg/financials.json'
import bgChat from '@/locales/bg/chat.json'
import bgSettings from '@/locales/bg/settings.json'
import bgPayment from '@/locales/bg/payment.json'
import bgPrivacy from '@/locales/bg/privacy.json'
import bgHelp from '@/locales/bg/help.json'
import bgSchedule from '@/locales/bg/schedule.json'

import enCommon from '@/locales/en/common.json'
import enAuth from '@/locales/en/auth.json'
import enDashboard from '@/locales/en/dashboard.json'
import enPatients from '@/locales/en/patients.json'
import enStaff from '@/locales/en/staff.json'
import enDocuments from '@/locales/en/documents.json'
import enFinancials from '@/locales/en/financials.json'
import enChat from '@/locales/en/chat.json'
import enSettings from '@/locales/en/settings.json'
import enPayment from '@/locales/en/payment.json'
import enPrivacy from '@/locales/en/privacy.json'
import enHelp from '@/locales/en/help.json'
import enSchedule from '@/locales/en/schedule.json'

export const defaultNS = 'common'

export const resources = {
  bg: {
    common: bgCommon,
    auth: bgAuth,
    dashboard: bgDashboard,
    patients: bgPatients,
    staff: bgStaff,
    documents: bgDocuments,
    financials: bgFinancials,
    chat: bgChat,
    settings: bgSettings,
    payment: bgPayment,
    privacy: bgPrivacy,
    help: bgHelp,
    schedule: bgSchedule,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    patients: enPatients,
    staff: enStaff,
    documents: enDocuments,
    financials: enFinancials,
    chat: enChat,
    settings: enSettings,
    payment: enPayment,
    privacy: enPrivacy,
    help: enHelp,
    schedule: enSchedule,
  },
} as const

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || 'bg',
  fallbackLng: 'bg',
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
})

export { i18n }
